import { useLazyQuery, useQuery } from "@apollo/client";
import { GROUP } from "../group.queries";
import { GroupQuery, GroupQueryVariables } from "../../../__generated__/GroupQuery";

export const useGroup = (id: number) => {
  return useQuery<GroupQuery, GroupQueryVariables>(GROUP, { variables: { id } });
};

export const useLazyGroup = () => {
  return useLazyQuery<GroupQuery, GroupQueryVariables>(GROUP);
};
